var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 80,
    viewBox: "0 0 160 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9462",
    "data-name": "Rectangle 9462",
    width: 160,
    height: 80,
    transform: "translate(880 655)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_592",
    "data-name": "Mask Group 592",
    transform: "translate(-880 -655)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(890 661.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-122",
    transform: "translate(0.07 67.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_254",
    "data-name": "Line 254",
    d: "M140,.5H0v-1H140Z",
    transform: "translate(0 0)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57417",
    "data-name": "Group 57417",
    transform: "translate(17.955 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Heart--inject-25",
    transform: "translate(28.751 14.074) rotate(-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72000",
    "data-name": "Path 72000",
    d: "M1.7,2.614c23.363-6.5,46.181-.2,54.389,11.344a28.477,28.477,0,0,1,3.848,7.455l-2.207.649a25.516,25.516,0,0,0-3.463-6.682C50.084,9.5,41.207,4.986,30.516,3.332,21.137,1.866,1.023,5.507,1.023,5.507S-1.678,3.552,1.7,2.614Z",
    transform: "translate(0 0)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57414",
    "data-name": "Group 57414",
    transform: "translate(26.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72001",
    "data-name": "Path 72001",
    d: "M0,0H54.682V63.679H0Z",
    transform: "translate(0 3.933)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9461",
    "data-name": "Rectangle 9461",
    width: 48.074,
    height: 58.514,
    transform: "translate(3.303 6.545)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72002",
    "data-name": "Path 72002",
    d: "M138.619,150.32h18.5c1.446,0,2.619.794,2.619,1.772v3.772H136v-3.759a1.544,1.544,0,0,1,.76-1.262,3.348,3.348,0,0,1,1.859-.524Z",
    transform: "translate(-120.528 -148.053)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72003",
    "data-name": "Path 72003",
    d: "M157.578,141.84h3.01a3.323,3.323,0,0,1,1.919.554,1.68,1.68,0,0,1,.79,1.36v.348H154.91v-.348a1.674,1.674,0,0,1,.775-1.35A3.3,3.3,0,0,1,157.578,141.84Z",
    transform: "translate(-131.761 -141.84)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1730",
    "data-name": "Line 1730",
    x2: 25.397,
    transform: "translate(10.665 19.661)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1731",
    "data-name": "Line 1731",
    x2: 8.287,
    transform: "translate(10.665 30.274)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1732",
    "data-name": "Line 1732",
    x2: 6.406,
    transform: "translate(10.665 40.889)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57415",
    "data-name": "Group 57415",
    transform: "translate(37.334 26.603) rotate(-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72004",
    "data-name": "Path 72004",
    d: "M9.558.01c5.1-.245,9.094,4.11,8.919,9.726S14.025,20.105,8.925,20.35-.169,16.241.006,10.624,4.457.255,9.558.01Z",
    transform: "translate(4.778 13.069) rotate(-45)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72005",
    "data-name": "Path 72005",
    d: "M9.558.01c5.1-.245,9.094,4.11,8.919,9.726S14.025,20.105,8.925,20.35-.169,16.241.006,10.624,4.457.255,9.558.01Z",
    transform: "translate(5.63 13.108) rotate(-45)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72006",
    "data-name": "Path 72006",
    d: "M.951,9.513,0,6.493c1.41-.431,5.034-1.438,8.5-2.806C11.817,2.374,15.5.614,16.727,0l1.255,2.752s-2.452,1.38-5.717,2.824A97.089,97.089,0,0,1,.951,9.513Z",
    transform: "translate(0 12.771)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72007",
    "data-name": "Path 72007",
    d: "M3.567,0A4.427,4.427,0,0,1,7.557,4.25,3.513,3.513,0,0,1,4,8.17,4.427,4.427,0,0,1,.006,3.923,3.513,3.513,0,0,1,3.567,0Z",
    transform: "translate(14.729 9.647)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72008",
    "data-name": "Path 72008",
    d: "M3.567,0A4.427,4.427,0,0,1,7.557,4.25,3.513,3.513,0,0,1,4,8.17,4.427,4.427,0,0,1,.006,3.923,3.513,3.513,0,0,1,3.567,0Z",
    transform: "translate(15.368 9.675)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57416",
    "data-name": "Group 57416",
    transform: "translate(48.056 28.342) rotate(-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72009",
    "data-name": "Path 72009",
    d: "M9.176,20.586C5.124,20.411,2.384,19.422,1,17.635a5,5,0,0,1-.744-4.613c.54-1.832,2.815-4.593,6.761-8.2C9.9,2.178,12.666,0,12.7,0l1.068,1.506c-3,2.339-10.985,9.1-11.905,12.223a3.017,3.017,0,0,0,.383,2.831c.916,1.18,3.873,3,13.376,1.913l.334,1.8a43.585,43.585,0,0,1-6.777.311Z",
    transform: "translate(8.341 23.162)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72010",
    "data-name": "Path 72010",
    d: "M15.889,10.835c-1.063-.046-2.13-.137-3.192-.278C4.638,9.487.486,6.034,0,0L1.675.016c.274,3.422,1.772,7.5,11.065,8.741s19.42-1.768,19.52-1.8l.591,1.756A57.578,57.578,0,0,1,15.889,10.835Z",
    transform: "translate(1.941 28.444)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72011",
    "data-name": "Path 72011",
    d: "M26.239,18.55c1.315-2.647,2.977-8.9.259-17.062A2.016,2.016,0,0,0,24.12.067a1.853,1.853,0,0,0-1.09,2.444c1.554,4.706,2.021,9.52.032,13.655-.66-.237-1.509-.515-2.481-.775-2.438-.654-4.231-.752-7.827.456C9.387,16.983,1.523,23.07.637,23.761A2.051,2.051,0,0,0,.421,26.5a1.834,1.834,0,0,0,2.564.576c2.288-1.783,8.754-6.59,11.176-7.4,2.96-.995,4.112-.879,5.869-.41a26.381,26.381,0,0,1,2.968.98,11.474,11.474,0,0,1,2.2,4.664c1,5.107-6.559,7.951-10.618,9.473l-.772.291a1.836,1.836,0,0,0-1.039,2.181,2.135,2.135,0,0,0,1.908,1.71,1.663,1.663,0,0,0,.655-.106l.753-.286c5.018-1.868,14.356-5.38,12.73-13.718A15.86,15.86,0,0,0,26.239,18.55Z",
    transform: "translate(18.149 0)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72012",
    "data-name": "Path 72012",
    d: "M2.5,5.883A2.737,2.737,0,0,1,.023,3.45,2.241,2.241,0,0,1,1.845.818c.019,0,1.941-.273,3.917-.757a2.6,2.6,0,0,1,2.97,1.932A2.332,2.332,0,0,1,7.224,5.03c-2.189.537-4.247.823-4.332.834a2.143,2.143,0,0,1-.4.019Z",
    transform: "translate(20.772 39.633)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72013",
    "data-name": "Path 72013",
    d: "M3.215,8.113A2.646,2.646,0,0,1,1,6.527,12.949,12.949,0,0,1,0,2.27,2.168,2.168,0,0,1,2.221,0,2.745,2.745,0,0,1,4.692,2.473,7.286,7.286,0,0,0,5.158,4.62a2.689,2.689,0,0,1-.046,2.41,2.067,2.067,0,0,1-1.9,1.08ZM4.7,2.473Z",
    transform: "translate(0 24.357)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72014",
    "data-name": "Path 72014",
    d: "M19.251,35.981C9.556,36.195,1.867,31.343.362,25.508-1.493,18.316,3.7,8.982,17.794,3.016A84.384,84.384,0,0,1,26.729,0l-.67,2.9C23.977,3.535,21,4.546,18.646,5.542,9.331,9.487,1.28,17.365,3.3,25.2c1.252,4.855,7.614,7.884,15.434,7.883a55.839,55.839,0,0,0,17.091-2.47L37,33.572A82.272,82.272,0,0,1,19.251,35.981Z",
    transform: "translate(0 23.526) rotate(-13)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/healthIcon.a12379b9888127e5e13514e5580d6065.svg";
export { ForwardRef as ReactComponent };